export enum CardType {
    boom = 'boom',
    zap = 'zap',
    lock = 'lock',
    key = 'key',
    plus_three = 'plus_three',
    value = 'value',
    anchor = 'anchor',
    crab = 'crab',
    tornado = 'tornado',
    joker = 'joker',
    gold = 'gold',
}
